var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.__drawer)?_c('m-navigation-drawer'):_vm._e(),_vm._v(" "),_c('v-main',{style:(_vm.__style),attrs:{"id":"app-main"}},[_c('nuxt')],1),_vm._v(" "),(_vm.__bottom)?_c('m-app-bottom'):_vm._e(),_vm._v(" "),_c('a-change-dialog'),_vm._v(" "),_c('a-snackbar'),_vm._v(" "),_c('m-app-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }